module.exports = __webpack_public_path__ + "img/sitting-by-tree-mask-back.4af72b27.png";